import { Link } from "react-router-dom";
import { Clock, ArrowUpRight } from "lucide-react";
import { fmtMoney } from "@/lib/format";

const IND_LABEL = { ai: "AI", "real-estate": "Real Estate", insurance: "Insurance", loans: "Loans" };

export default function CourseCard({ course, symbol }) {
  const sym = symbol || course.symbol || "₹";
  return (
    <Link
      to={`/courses/${course.slug}`}
      data-testid={`course-card-${course.slug}`}
      className="asf-card overflow-hidden flex flex-col group"
    >
      <div className="relative h-44 overflow-hidden">
        <img src={course.image} alt={course.title} loading="lazy"
          className="h-full w-full object-cover opacity-80 group-hover:opacity-100 group-hover:scale-105 transition-all duration-500" />
        <div className="absolute inset-0 bg-gradient-to-t from-asf-elevated to-transparent" />
        <span className="absolute top-3 left-3 asf-overline bg-asf-app/70 px-2.5 py-1 rounded-full">
          {IND_LABEL[course.industry]}
        </span>
      </div>
      <div className="p-6 flex flex-col flex-1">
        <h3 className="font-display text-xl font-semibold leading-tight">{course.title}</h3>
        <p className="text-sm text-slate-500 mt-2 line-clamp-2 flex-1">{course.overview}</p>
        <div className="flex items-center gap-2 mt-4 text-xs text-slate-500">
          <Clock className="h-3.5 w-3.5" /> {course.duration_hours} hours · Certificate
        </div>
        <div className="flex items-center justify-between mt-5 pt-4 border-t border-slate-100">
          <span className="font-display text-2xl font-bold">{fmtMoney(sym, course.price)}</span>
          <span className="flex items-center gap-1 text-sm text-asf-orange font-semibold">
            View <ArrowUpRight className="h-4 w-4" />
          </span>
        </div>
      </div>
    </Link>
  );
}
